import { render } from "./FollowUs.vue?vue&type=template&id=d6300550&scoped=true"
const script = {}

import "./FollowUs.vue?vue&type=style&index=0&id=d6300550&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6300550"]])

export default __exports__